import { render, staticRenderFns } from "./EventTests.vue?vue&type=template&id=2349aa40&"
import script from "./EventTests.vue?vue&type=script&lang=js&"
export * from "./EventTests.vue?vue&type=script&lang=js&"
import style0 from "./EventTests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EventTests.vue"
export default component.exports